import React from 'react';
import { FaHardHat, FaRoad } from 'react-icons/fa';
import IconBox from './IconBox';

function AboutFeatured() {
    const aboutImg = '/section2-image.jpg';

    return (
        <>
            <section className="about-featured-wrapper section-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-5 col-12">
                            <div
                                className="about-promo bg-cover"
                                style={{
                                    backgroundImage: `url(${aboutImg})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat'
                                }}
                            >
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-7 col-12 mt-5 mt-lg-0">
                            <div className="block-contents ml-lg-5">
                                <span>Australian Engineering Excellence</span>
                                <h1>ProtoPath delivers innovative solutions locally.</h1>
                                <h4>
                                    As a proud Australian business, we bring world-class rapid prototyping
                                    and manufacturing expertise to clients across the nation.
                                </h4>
                            </div>

                            <div className="icon-boxs ml-lg-5">
                                <IconBox
                                    icon={<FaHardHat />}
                                    heading="Local Expertise"
                                    text="Australian-based engineering team with deep understanding of local industry standards and ISO requirements"
                                />
                                <IconBox
                                    icon={<FaRoad />}
                                    heading="Nationwide Service"
                                    text="Delivering comprehensive prototyping and manufacturing solutions to businesses across Australia"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default AboutFeatured;
